const INVITE_PATH = /(\/invite\/)[0-9a-f]{48}(?=[/?#\s]|$)/gi;
const ACTIVATION_PATH = /((?:\/api\/accounts)?\/activate\/)[A-Za-z0-9_-]{43,128}(?=[/?#\s]|$)/gi;
const SLACK_LINK_PATH = /((?:\/api\/slack\/link|\/connect\/slack)\/)[A-Za-z0-9_-]{43,128}(?=[/?#\s]|$)/gi;
const RAW_INVITE_TOKEN = /\b[0-9a-f]{48}\b/gi;
const RAW_ACTIVATION_TOKEN = /\b[A-Za-z0-9_-]{43}\b/g;
const SENSITIVE_QUERY = /([?&](?:token_hash|token|code|access_token|refresh_token)=)[^&#\s]+/gi;
const SENSITIVE_FIELD = /(["']?(?:token_hash|token|code|access_token|refresh_token)["']?\s*[:=]\s*["']?)[^"'\s,&}]+/gi;
const JWT = /\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\b/g;

export function redactSensitiveString(value: string): string {
  // Browser URLs frequently contain a second URL inside `next`, encoded once
  // or twice. Normalize percent encoding before matching so nested bearer
  // credentials cannot evade the direct-path/query patterns.
  let normalized = value;
  for (let pass = 0; pass < 2; pass += 1) {
    try {
      const decoded = decodeURIComponent(normalized);
      if (decoded === normalized) break;
      normalized = decoded;
    } catch {
      break;
    }
  }

  return normalized
    .replace(/[\u0000-\u001f\u007f]/g, " ")
    .replace(INVITE_PATH, "$1[REDACTED]")
    .replace(ACTIVATION_PATH, "$1[REDACTED]")
    .replace(SLACK_LINK_PATH, "$1[REDACTED]")
    .replace(SENSITIVE_QUERY, "$1[REDACTED]")
    .replace(SENSITIVE_FIELD, "$1[REDACTED]")
    .replace(RAW_INVITE_TOKEN, "[REDACTED_INVITE_TOKEN]")
    .replace(RAW_ACTIVATION_TOKEN, "[REDACTED_ACTIVATION_TOKEN]")
    .replace(JWT, "[REDACTED_JWT]");
}

/** Defense-in-depth for structured data received by the server log endpoint. */
export function redactSensitiveLogValue(value: unknown, depth = 0): unknown {
  if (depth > 8) return "[TRUNCATED]";
  if (typeof value === "string") return redactSensitiveString(value);
  if (Array.isArray(value)) {
    return value.slice(0, 100).map((item) => redactSensitiveLogValue(item, depth + 1));
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .slice(0, 100)
        .map(([key, item]) => [key, redactSensitiveLogValue(item, depth + 1)])
    );
  }
  return value;
}
